import {Component, inject, OnInit, signal} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router, RouterModule} from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import {AuthService} from "@/pages/service/auth.service";
import {Client, LoginRequest} from "@/api/client";
import {MessageService} from "primeng/api";
import {NgTemplateOutlet} from "@angular/common";
import {RecaptchaModule} from "ng-recaptcha";
import {environment} from "@/environment/environment";
import {IconField} from "primeng/iconfield";


@Component({
    selector: 'app-login',
    standalone: true,
    imports: [ButtonModule, RecaptchaModule, CheckboxModule, InputTextModule, PasswordModule, FormsModule, RouterModule, RippleModule, NgTemplateOutlet, ReactiveFormsModule, IconField],
    templateUrl: './login.html'

})
export class Login implements OnInit {
    authService = inject(AuthService);
    router = inject(Router);
    messageService = inject(MessageService);
    client = inject(Client)
    loading = signal(false);
    protected publicKey = environment.reCAPTCHA.PublicKey;
    showRecover = false;
    loginTmpl = true;

    loginForm = new FormGroup({
        login: new FormControl<string>('', Validators.required),
        password: new FormControl<string>('', Validators.required),
        rememberMe: new FormControl<boolean>(false),
        remoteIpAddress: new FormControl<string>('')
    })

    restorePasswordForm = new FormGroup({
        password: new FormControl<string>('', [Validators.required]),
        captcha: new FormControl<string>('', [Validators.required]),
    });

    ngOnInit() {
        if (this.authService.isAuth()) {
            this.router.navigate(['/settings']);
        }
    }

    restorePassword(): void {
        if (this.restorePasswordForm.invalid) return
        this.loading.set(true);
        const data = {
            password: this.restorePasswordForm.get('password')?.value!,
            captcha: this.restorePasswordForm.get('captcha')?.value!,
        }
        this.client.account_RestorePas(data).subscribe({
            next: () => {
                this.loading.set(false)
                this.router.navigate(['/auth/login']);
            },
            error: (errorMessage) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Ошибка',
                    detail: errorMessage.message
                });
                this.loading.set(false)
            }
        })
    }

    showRecovery() {
        this.showRecover = !this.showRecover
        this.loginTmpl = !this.loginTmpl;
    }

    resolved(captchaResponse: string) {
        this.restorePasswordForm.get('captcha')!.setValue(captchaResponse);
    }

    logging () {
        if (this.loginForm.invalid) return
        this.loading.set(true);
        let data = {
            login: this.loginForm.get('login')?.value!,
            password: this.loginForm.get('password')?.value!,
            remoteIpAddress: this.loginForm.get('remoteIpAddress')?.value!,
            rememberMe: this.loginForm.get('rememberMe')?.value!,
        } as LoginRequest;
        this.authService.login(data)
            .subscribe({
                next: () => {this.loading.set(false)},
                error: () => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Ошибка',
                        detail: 'Неверный логин или пароль'
                    });
                    this.loading.set(false)
                }
            });
    }

}
